module.exports = __webpack_public_path__ + "static/media/Kit de Apoyo E4.446625df.zip";